import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'

type WrapperProps = {
  direction?: 'right' | 'left' | 'spaceBetween'
}

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  ${({ theme }) => `
    margin-bottom: -${theme.space.mobile.tiny};

    button {
      margin-bottom: ${theme.space.mobile.tiny};
      margin-left: ${theme.space.mobile.tiny};
    }
  `}

  ${({ theme, direction }) =>
    direction === 'left' &&
    `
    justify-content: flex-start;
    
    button {
      margin-right: ${theme.space.mobile.tiny};
      margin-left: 0;
    }
  `}

  ${({ theme }) => media.sm`
    margin-bottom: -${theme.space.desktop.tiny};

    button {
      margin-bottom: ${theme.space.desktop.tiny};
      margin-left: ${theme.space.desktop.tiny};
    }
  `}

  ${({ theme, direction }) =>
    direction === 'left' &&
    media.sm`
    button {
      margin-right: ${theme.space.desktop.tiny};
      margin-left: 0;
    }
  `}

  ${({ direction }) =>
    direction === 'spaceBetween' &&
    `
    justify-content: space-between;
    
    button {
      margin-right: 0;
      margin-left: 0;
    }
  `}
`

export const ModalWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  ${({ theme }) => `
    button + button {
      margin-left: ${theme.space.mobile.base};
    }
  `}

  ${media.sm`
    justify-content: flex-end;
  `}
`
